import { RiShareForwardLine } from "react-icons/ri"

import SolidBtn from "@fuse/sharedComponents/buttons/SolidBtn"
import { EIcons } from "@letshang/constants"
import { get, size } from "lodash-es"

import JoinExternalEventIcon from "@fuse/assets/icons/icon-join-external-event.svg"
import ShareEventIcon from "@fuse/assets/images/eventSignUp/img-icon-share.svg"
// import { EButtonType } from "@screens/Activities/component/ActivityCard/useRegularActivityCard"

import TicketOutlineIcon from "@fuse/assets/images/eventSignUp/img-icon-ticket-outline-alpha.svg"

export interface TAdminActions {
  disabled?: boolean
  title: string
  buttonClassName?: string
  labelClassName?: string
  buttonColor?: string
  iconName?: string
}

export const icons = {
  [EIcons.ticketOutlineIcon]: TicketOutlineIcon,
  [EIcons.shareEventIcon]: ShareEventIcon,
  [EIcons.joinShareForwardIcon]: <RiShareForwardLine />,
  [EIcons.joinExternalEventIcon]: JoinExternalEventIcon,
}

interface PropsTypes {
  buttonOptionList: Array<TAdminActions>
  handleScreen?: (value?: number) => Promise<void> | void
  bottomActionClassName?: string
  buttonWrapperClassName?: string
  solidBtnClassName?: string
}

export default function BottomAction({
  handleScreen,
  buttonOptionList,
  bottomActionClassName,
  buttonWrapperClassName,
  solidBtnClassName,
}: PropsTypes) {
  const buttonOptionSize = size(buttonOptionList)
  const buttonOptionContainer = `grid-cols-${buttonOptionSize < 2 ? 2 : buttonOptionSize}`
  return (
    <div
      className={`flex flex-wrap gap-4 ${buttonOptionContainer} ${bottomActionClassName}`}
    >
      {buttonOptionList.map((option, index: number) => {
        const disabled = get(option, "disabled", false)
        const label = get(option, "title", "")
        const isLoading = get(option, "isLoading", false)

        const buttonClassName = get(option, "buttonClassName", "")
        const labelClassName = get(option, "labelClassName", "")
        const buttonColor = get(option, "buttonColor", "")
        const Icon = icons[get(option, "iconName", "") as keyof typeof icons]
        const buttonVariant = get(option, "buttonVariant", "solid")

        const disabledButtonCursor = disabled ? "pointer-events-none" : ""

        // return (
        //   <SolidBtn
        //     key={index.toString()}
        //     icon={Icon}
        //     style={buttonColor ? { backgroundColor: buttonColor } : {}}
        //     label={label}
        //     className={[
        //       "px-[20px] py-2 flex-row",
        //       buttonClassName,
        //       disabled ? "pointer-events-none" : "",
        //     ]
        //       .filter(Boolean)
        //       .join(" ")}
        //     labelClassName={"font-medium text-[16x] " + labelClassName}
        //     onClick={() => handleScreen && handleScreen(index)}
        //     disabled={disabled}
        //   />
        // );

        return (
          <div
            key={index}
            className={`flex-shrink-0 w-full sm:w-auto ${buttonWrapperClassName}`}
          >
            <SolidBtn
              key={index.toString()}
              size="lg"
              variant={buttonVariant}
              disabled={disabled}
              isLoading={isLoading}
              icon={Icon}
              onClick={() => handleScreen && handleScreen(index)}
              className={`inline-flex text-white opacity-100 px-10 min-w-48 w-full sm:w-auto flex-1 ${solidBtnClassName}`}
            >
              {label}
            </SolidBtn>
          </div>
        )
      })}
    </div>
  )
}
